import React, { useContext, useEffect, useState } from 'react';
import {
  IconButton,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from '@material-ui/core';
import { Create } from '@material-ui/icons';

import { useHistory } from 'react-router-dom';

import moment from 'moment';

import PropTypes from 'prop-types';

import AlertDialog1Option from '../modals/alertDialog1Option';
// import CustomCircle from './customCircle';
import SearchField from './searchField';
import SpinnerLoading from '../feedback/spinnerLoading';
import TablePaginationActions from './tablePaginationActions';
import UserScheduleStatusIcon from './userScheduleStatusIcon';

import { getProgramSchedulingPatterns } from '../../utils/comms';
import { filteredSearch, getComparator, remainingDays, stableSort } from '../../utils/helpers';

import { defaultRowsPerPage, defaultSortOrder, extraDays, rowsPerPageOptions } from '../../utils/constants';

import translations from '../../languages/i18n';

import { customOptionsTableStyles } from '../../styles/formElementsStyles';

import { SessionContext } from '../../utils/context';

export default function FormsSection({ fillInFormsPlatforms, patientId, programId, userSchedulesData, userType }) {
  const history = useHistory();
  const sessionContext = useContext(SessionContext);

  const classesForm = customOptionsTableStyles();

  const [adaptedUserSchedulesData, setAdaptedUserSchedulesData] = useState([]);
  const [externalPlatforms, setExternalPlatforms] = useState([]);
  const [filteredUserSchedules, setFilteredUserSchedules] = useState([]);
  const [infoReady, setInfoReady] = useState(false);
  const [order, setOrder] = React.useState(defaultSortOrder); // Indica l'ordre per defecte
  const [orderBy, setOrderBy] = React.useState('adaptedFrom'); // Indica la columna per la que ordenam per defecte
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [schedulingPatterns, setSchedulingPatterns] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [showExternalPlatforms, setShowExternalPlatforms] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  // Adapta els UserSchedules al format que es necessita per ordenar-los emprant la funció gènerica de comparació (la que es crida a getComparator)
  const adaptUserSchedules = (userSchedules) => {
    const out = [];
    userSchedules.map((userSchedule) => {
      out.push({
        ...userSchedule,
        translatedName: translations[userSchedule.name],
        adaptedFrom: moment(userSchedule.from).format('YYYY-MM-DD'), // ATENCIÓ: el format no pot ser DD-MM-YYYY ja que no funciona la funció d'ordenació (descendingComparator) i la consola del navegador mostra un warning de que el format serà deprecated
        adaptedTo: moment(userSchedule.from).add(userSchedule.daysToFillIn, 'days').format('YYYY-MM-DD'), // Idem
      });
    });
    return out;
  };

  useEffect(() => {
    // Demanam els schedulingPatterns del programa per poder pintar, a la taula, la descripció del schedulingPatterns en lloc del id
    const getSchedulingPatternsFromServer = async () => {
      setShowLoading(true);
      const response = await getProgramSchedulingPatterns(programId, sessionContext.userToken);
      if (response.status === 200) { // Tenim llistat
        setSchedulingPatterns(response.data.schedulingPatterns);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
      setShowLoading(false);
      setInfoReady(true);
    };
    getSchedulingPatternsFromServer();
    const adaptedUserSchedules = adaptUserSchedules(userSchedulesData);
    setAdaptedUserSchedulesData(adaptedUserSchedules);
    setFilteredUserSchedules(adaptedUserSchedules);
    setSearchString('');
    // Ordenam de nou el llistat per la columna i sentit per defecte. Si volem mantenir l'ordenació que hi havia abans de que es refresqui el
    // llistat de formularis, llevar les dues línies següents:
    setOrder(defaultSortOrder);
    setOrderBy('adaptedFrom');
  }, [userSchedulesData]);

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleViewUserSchedule = (userScheduleId, userScheduleRole) => {
    let fillInOnExternalPlatforms = false;
    // Si l'usuari és de tipus clínic miram si el formulari s'ha de contestar des d'alguna plataforma que no sigui la web del servidor (ICHOM_web)
    if (userScheduleRole === 'Clinician') {
      fillInOnExternalPlatforms = fillInFormsPlatforms[userScheduleRole] && !fillInFormsPlatforms[userScheduleRole].includes('ICHOM_web');
    }
    if (fillInOnExternalPlatforms) {
      setExternalPlatforms(fillInFormsPlatforms[userScheduleRole]);
      setShowExternalPlatforms(true);
    } else {
      history.push(`/${sessionContext.role.toLowerCase()}/formInfo/${programId}/${userScheduleId}`);
    }
  };

  const manageExternalPlatforms = () => {
    setShowExternalPlatforms(false);
    setExternalPlatforms([]);
  };

  // Funció antiga per calcular els dies que falten tenint en compte l'hora exacte del formulari
  /* const remainingDays_exact = (from, daysToFillIn) => {
    const now = Date.now(); // En milisegons des de 01/01/1970 en HORA LOCAL (GMT + alguna cosa)
    // Date.parse(from) dona els milisegons que han passat des de 01/01/1970 en HORA LOCAL (GMT + alguna cosa)
    // Al servidor les dates es guarden en hora Zulu (que equival a un desfase de +00:00), en fer el Date del que rebem del servidor
    // ens torna la data en HORA LOCAL (GMT + alguna cosa) o al manco això he deduit de les proves
    let remainingDaysToFillIn = '';
    if (now >= Date.parse(from) && now <= (Date.parse(from) + daysToFillIn * 24 * 60 * 60 * 1000)) { // El formulari està obert o es pot editar
      const remaining = (Date.parse(from) + daysToFillIn * 24 * 60 * 60 * 1000) - now;
      if (remaining > 0) {
        remainingDaysToFillIn = Math.round(remaining / (24 * 60 * 60 * 1000)).toString();
      } else {
        remainingDaysToFillIn = '0';
      }
    }
    return remainingDaysToFillIn;
  }; */

  // Funció antiga tenint en compte l'hora exacte del formulari
  /* const userScheduleStatus_exact = (from, daysToFillIn, resultSet) => {
    let now = Date.now(); // En milisegons des de 01/01/1970 en HORA LOCAL (GMT + alguna cosa)
    // Date.parse(from) dona els milisegons que han passat des de 01/01/1970 en HORA LOCAL (GMT + alguna cosa)
    // Al servidor les dates es guarden en hora Zulu (que equival a un desfase de +00:00), en fer el Date del que rebem del servidor
    // ens torna la data en HORA LOCAL (GMT + alguna cosa) o al manco això he deduit de les proves

    // Afegesc 1 minut a now per assegurar que els formularis amb el from del dia actual es pintin desbloquejats en repintar aquest component
    // A vegades en repintar el component, just després de crear un event amb data del dia actual per questió de segons el formulari creat per l'event es pintava bloquejat (perque el now es més petit que el Date.parse(from))
    now += 1 * 60 * 1000;

    let status = '';
    if (now >= Date.parse(from) && now <= (Date.parse(from) + daysToFillIn * 24 * 60 * 60 * 1000)) {
      status = resultSet ? 'editable' : 'opened';
    } else { // No fa falta fer la comprovació de si now < from o si now > from + daysToFillIn ja que només tenim els userSchedules no caducats
      status = 'notOpened';
    }
    return status;
  }; */

  const userScheduleStatus = (from, daysToFillIn, resultSet) => {
    const today = moment().format('YYYY-MM-DD');
    const firstDay = moment(from).format('YYYY-MM-DD');
    const lastDay = moment(from).add(daysToFillIn + extraDays, 'days').format('YYYY-MM-DD'); // Afegim extraDays (normalment 1) al daysToFillIn perquè començam a comptar els dies a partir del dia següent al from
    let status = '';
    if (moment(today).isSameOrAfter(firstDay) && moment(today).isBefore(lastDay)) { // ATENCIÓ: la segona condició és isBefore i no isSameOrBefore ja que lastDay ja inclou el dia "extra"
      status = resultSet ? 'editable' : 'opened';
    } else { // No fa falta fer la comprovació de si now < from o si now > from + daysToFillIn ja que només tenim els userSchedules no caducats
      status = 'notOpened';
    }
    return status;
  };

  // A part d'anar alternant el color de fons de les files,
  // destacam amb uns altres colors el fons de la fila corresponent a un formulari actiu o pendent
  const customBgStyle = (index) => {
    if (index % 2) return classesForm.tableRowBgColor1;
    return classesForm.tableRowBgColor2;
  };

  // Del llistat d'userSchedules l'usuari només podrà respondre els que tengui assignats i que no estiguin tancats
  // EL botó està habilitat (disabled=false) quan el formulari és de l'usuari i està actiu o editable
  const disableIconButton = (user, from, daysToFillIn, resultSet) => {
    let disabled;
    // L'administrador de l'app no pot veure les respostes dels formularis
    if (userType === 'AppAdmin') return true;
    // Per a la resta d'usuaris, si el formulari està obert permetem accedir-hi segons el tipus d'usuari
    if (userScheduleStatus(from, daysToFillIn, resultSet) !== 'notOpened') {
      // Si el formulari és del propi usuari o l'usuari és supervisor o administrador pot consultar-lo
      if (user === sessionContext.userId || userType === 'Supervisor' || userType === 'Administrator') {
        disabled = false;
      } else {
        disabled = true;
      }
    } else { // El formulari està tancat
      disabled = true;
    }
    return disabled;
  };

  /* const obtainDescription = (schedulingPatternId) => {
    // TODO: si s'ha de poder cercar pel camp descripció del schedullingPattern, s'ha d'afegir al filteredUserSchedules la descripció que correspon a cada identificador
    // Ara malgrat es mostra la descripció, la cerca es fa per l'id del schedullingPattern
    // Si tenim schedulingPatterns tornam la descripció
    if (schedulingPatterns.length !== 0) return schedulingPatterns.find((pattern) => pattern._id === schedulingPatternId).desc;
    // Si no tenim schedulingPatterns, vol dir que la comunicació no ha anat bé
    return translations['_infoNotAvailable'];
  }; */

  const searchUserSchedule = (string) => {
    setPage(0);
    setSearchString(string);
    // ATENCIÓ: cercam sobre el nom traduit del formulari (translatedName), el que es veu per pantalla, no sobre el nom intern del formulari (name)
    setFilteredUserSchedules(filteredSearch(adaptedUserSchedulesData, string, ['username', 'translatedName']));
  };

  const userSchedulesDataColumns = 4; // Per saber el nombre de propietats de cada objecte

  return (
    <React.Fragment>
      <SpinnerLoading show={showLoading} />
      <AlertDialog1Option open={showExternalPlatforms} handleClose={manageExternalPlatforms} title={translations['_externalPlatformsAlertTitle']} message={translations['_externalPlatformsAlertMessage']} data={externalPlatforms} />
      {infoReady && (
        <Grid container justify='flex-start' spacing={2}>
          <Grid item xs={12}>
            <Typography variant='h6' component='div'>{translations['_forms']}</Typography>
          </Grid>
          {(userSchedulesData.length !== 0 && (
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label='userSchedules list table'>
                  <TableHead>
                    <TableRow>
                      {/* ATENCIÓ: si pintam la columna _id afegir +1 al colSpan */}
                      <TableCell colSpan={userSchedulesDataColumns + 2} align='left' padding='none'>
                        <SearchField handleChange={(string) => searchUserSchedule(string)} value={searchString} />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow className={classesForm.tableRowHeaderBgColor}>
                      {/* ATENCIÓ: no pintam la columna _id */}
                      <TableCell align='left'><strong>{translations['_state']}</strong></TableCell>
                      <TableCell align='left'>
                        <TableSortLabel
                          active={orderBy === 'name'}
                          direction={orderBy === 'name' ? order : 'asc'}
                          onClick={() => handleRequestSort('name')}
                        >
                          <strong>{translations['_name']}</strong>
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align='left'>
                        <TableSortLabel
                          active={orderBy === 'username'}
                          direction={orderBy === 'username' ? order : 'asc'}
                          onClick={() => handleRequestSort('username')}
                        >
                          <strong>{translations['_assignedTo']}</strong>
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align='left'>
                        <TableSortLabel
                          active={orderBy === 'adaptedFrom'}
                          direction={orderBy === 'adaptedFrom' ? order : 'asc'}
                          onClick={() => handleRequestSort('adaptedFrom')}
                        >
                          <strong>{translations['_from']}</strong>
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align='left'>
                        <TableSortLabel
                          active={orderBy === 'adaptedTo'}
                          direction={orderBy === 'adaptedTo' ? order : 'asc'}
                          onClick={() => handleRequestSort('adaptedTo')}
                        >
                          <strong>{translations['_to']}</strong>
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align='center' />{/* Columna per al botó de veure */}
                    </TableRow>
                    {(rowsPerPage > 0
                      ? stableSort(filteredUserSchedules, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : stableSort(filteredUserSchedules, getComparator(order, orderBy))
                    ).map((userSchedule, index) => (
                      <TableRow key={userSchedule._id} className={customBgStyle(index)} hover>
                        {/* ATENCIÓ: no pintam la columna _id */}
                        {/* <TableCell align='left'>{isActive(userSchedule.from, userSchedule.daysToFillIn) ? <strong>{translations['_active'].toUpperCase()}</strong> : translations['_inactive']}</TableCell> */}
                        {/* <TableCell align='left'><CustomCircle status={userScheduleStatus(userSchedule.from, userSchedule.daysToFillIn, , userSchedule.resultset)} remainingDays={3} /></TableCell> */}
                        <TableCell align='left'>
                          <UserScheduleStatusIcon
                            remainingDays={remainingDays(userSchedule.from, userSchedule.daysToFillIn) > 0 ? remainingDays(userSchedule.from, userSchedule.daysToFillIn).toString() : ''}
                            status={userScheduleStatus(userSchedule.from, userSchedule.daysToFillIn, userSchedule.resultset)}
                            // Miram qui és el propietari del formulari
                            // ALERTA: hi ha un operador ternari anidat en cas de que la primera condició doni fals (vendria a ser un else if)
                            // Si l'usuari al que està assignat el userSchedule no es correspon al id del pacient, vol dir que és d'un clínic i hem de mirar si es correspon al clínic que consulta els formularis o un altre
                            userScheduleOwner={userSchedule.user === patientId ? 'patient' : userSchedule.user === sessionContext.userId ? 'clinic' : 'otherClinic'}
                          />
                        </TableCell>
                        <TableCell align='left'>{translations[userSchedule.name]}</TableCell>
                        <TableCell align='left'>{userSchedule.username}</TableCell>
                        <TableCell align='left'>{moment(userSchedule.from).format('DD-MM-YYYY')}</TableCell>
                        <TableCell align='left'>{moment(userSchedule.adaptedTo).format('DD-MM-YYYY')}</TableCell>
                        <TableCell align='center'>
                          <IconButton
                            disabled={disableIconButton(userSchedule.user, userSchedule.from, userSchedule.daysToFillIn, userSchedule.resultset)}
                            onClick={() => handleViewUserSchedule(userSchedule._id, userSchedule.role)}
                          >
                            <Create />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        colSpan={userSchedulesDataColumns + 2}
                        count={filteredUserSchedules.length}
                        rowsPerPageOptions={rowsPerPageOptions}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        }}
                        labelDisplayedRows={({ from, to, count }) => from + ' - ' + ((to !== -1 && to) || count) + ' ' + translations['_of'] + ' ' + ((count !== -1 && count) || (translations['_moreThan'] + ' ') + to)}
                        labelRowsPerPage={translations['_rowsPerPage']}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Grid>
          )) || (
            <Grid item xs={12}>
              <Typography variant='body1' component='div'>{translations['_emptyList']}</Typography>
            </Grid>
          )}
        </Grid>
      )}
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
FormsSection.propTypes = {
  fillInFormsPlatforms: PropTypes.object.isRequired,
  patientId: PropTypes.string.isRequired,
  programId: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired,
  userSchedulesData: PropTypes.array.isRequired,
};
